module.exports = __webpack_public_path__ + "static/illustration-1-f5308921a9af44d55bb7c6de839e6744.svg";